const SearchInputBox = ({ title, value, placeholder = null, size, disabled = false, onClick }) => {
    return (
        <div
            className={
                'form-box' +
                (size != undefined ? (size == 'small' ? ' w-sm' : size == 'medium' ? ' w-md' : ' w-lg') : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <input
                        id={title}
                        type='text'
                        className='form-control form-search '
                        value={value == undefined || value == null ? '' : value}
                        placeholder={placeholder}
                        disabled={disabled}
                        readOnly={true}
                        onClick={onClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default SearchInputBox;
